var _excluded = ["checked", "children", "className", "disabled", "name", "onClick", "value", "wrap"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import "./ARadio.scss";
var ARadio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    children = _ref.children,
    propsClassName = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    name = _ref.name,
    onClick = _ref.onClick,
    value = _ref.value,
    wrap = _ref.wrap,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-radio";
  if (disabled) {
    className += " a-radio--disabled";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("label", _extends({}, rest, {
    ref: ref,
    className: className
  }), /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    className: "a-radio__input",
    value: value,
    onChange: function onChange() {},
    disabled: disabled,
    onClick: onClick,
    "aria-checked": checked,
    ref: function ref(el) {
      return el && (el.checked = checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "a-radio__box"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a-radio__box__outer",
    r: "7",
    cy: "7",
    cx: "7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a-radio__box__inner",
    r: "3",
    cy: "7",
    cx: "7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a-radio__box__active",
    r: "2.5",
    cy: "7",
    cx: "7"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "a-radio__label".concat(wrap ? " a-radio__label--wrap" : "")
  }, children));
});
ARadio.defaultProps = {
  checked: false,
  disabled: false
};
ARadio.propTypes = {
  /**
   * Toggles the `checked` state.
   */
  checked: PropTypes.bool,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * The input's name.
   */
  name: PropTypes.string,
  /**
   * A callback for handling the click event.
   */
  onClick: PropTypes.func,
  /**
   * The input's value.
   */
  value: PropTypes.string,
  /**
   * Toggles wrapping of long text in the label.
   */
  wrap: PropTypes.bool
};
ARadio.displayName = "ARadio";
export default ARadio;